/*
 * @description:
 * @author: Jason Wong
 * @since: 2024-07-11 10:32:25
 */
import Vue from "vue";

import WidgetContainer from "../components/widgetContainer.vue";
Vue.component("dyrs-widget-container", WidgetContainer);

//schoolManager's widgets
import schoolMgrWidge from "./packages/schoolMgr/index.vue";
Vue.component("schoolMgr-widget", schoolMgrWidge);

//normal user's widgets
import normalUserWidge from "./packages/normalUser/index.vue";
Vue.component("normalUser-widget", normalUserWidge);

function emptyGeneratorFunc() {
  return [];
}
let widgetGroupFactory = {
  widgetSingletons: ["schoolMgr-widget", "normalUser-widget"],
  widgetGroups: {},
  register(name, funcHandler) {
    this.widgetGroups[name] = funcHandler;
  },
  get(name) {
    if (this.widgetSingletons.indexOf(name) >= 0) return name;
    if (name in this.widgetGroups) return this.widgetGroups[name];
    else return emptyGeneratorFunc;
  },
};

export { widgetGroupFactory };
